if (!customElements.get("custom-reviews-new")) {
  customElements.define(
    "custom-reviews-new",
    class CustomReviewsNew extends HTMLElement {
      constructor() {
        super();
        this.jsonarr = [];
        this.category = $(this).data("category");
        this.fabric = $(this).data("fabric");
        this.year = $(this).data("year");
        this.make = $(this).data("make");
        this.model = $(this).data("model");

        this.loaddata();
        this.swiper = null;
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata() {
        var csvurl = $(this).data("csvurl");
        var href = new URL(csvurl);
        var random = Math.floor(Math.random() * 100000000);
        href.searchParams.set("v", random);
        csvurl = href.toString();

        var this3 = this;

        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["index"] = index;
              ob["ratingall"] = word_array[index][0];
              ob["ratinglabel1"] = word_array[index][1];
              ob["rating1"] = word_array[index][2];
              ob["ratinglabel2"] = word_array[index][3];
              ob["rating2"] = word_array[index][4];
              ob["ratinglabel3"] = word_array[index][5];
              ob["rating3"] = word_array[index][6];
              ob["heading"] = word_array[index][7];
              ob["content"] = word_array[index][8];
              ob["author"] = word_array[index][9];
              ob["authorloc"] = word_array[index][10];
              ob["ptitle"] = word_array[index][11].replace("�", "®");
              ob["pdetails"] = word_array[index][12];
              this3.jsonarr.push(ob);
            }

            setDataInPage(this3.jsonarr, 1);

            generatePagination();
            setDates();

            window.addEventListener(
              "resize",
              function (event) {
                setDataInPage(this3.jsonarr, 1);

                generatePagination();
                setDates();
              },
              true
            );
          },
        });

        const chunk = (arr, size) =>
          Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
          );

        function setDataInPage(data, current) {
          var result = [];
          var datarr = data;
          if (window.matchMedia("(min-width: 740px)").matches) {
            result = chunk(data, 2);

            var str = "";
            str = str + `<div class="swiper mySwiper">`;
            str = str + `<div class="swiper-wrapper">`;
            result.forEach((initem) => {
              str = str + `<div class="swiper-slide">`;
              initem.forEach((item) => {
                var rating1 = "";
                var r1count = parseInt(item.rating1) || 5;
                for (var i = 0; i < r1count; i++) {
                  rating1 =
                    rating1 + `<div class="progress-active-item"> </div>`;
                }
                var rating2 = "";
                var r2count = parseInt(item.rating2) || 5;
                for (var i = 0; i < r2count; i++) {
                  rating2 =
                    rating2 + `<div class="progress-active-item"> </div>`;
                }
                var rating3 = "";
                var r3count = parseInt(item.rating3) || 5;
                for (var i = 0; i < r3count; i++) {
                  rating3 =
                    rating3 + `<div class="progress-active-item"> </div>`;
                }
                var ratingtotal = "";
                var totalRating = r1count + r2count + r3count;
                var totalper = item.ratingall;
                var totalpercentage = totalper;
                for (var i = 0; i < 5; i++) {
                  if (i < totalper) {
                    ratingtotal =
                      ratingtotal +
                      `<svg id="Star" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25">
                      <path id="Path_2712" data-name="Path 2712" d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" transform="translate(-207.22 1546.716)" stroke="#EB7100" fill="#EB7100"></path>
                    </svg>`;
                  } else {
                    ratingtotal =
                      ratingtotal +
                      `<svg id="Star" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25">
                      <path id="Path_2712" data-name="Path 2712" d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" transform="translate(-207.22 1546.716)" stroke="#EB7100" fill="transparent"></path>
                    </svg>`;
                  }
                }
                str =
                  str +
                  `<div class="custom-review-wrapper">
                         <div class="custom-review-star-block"> 
                          <div class="custom-review-heading font-size-20 font-size-mob-17 font-weight-600" style="color:#4d4d4d;">${item.heading}</div>
                          <div class="custom-main-star-rating"><div class="stars-wrapper">${ratingtotal}</div> <span>${totalpercentage}/5</span></div>
                          <div class="custom-review-star-wrapper"> 
                             <div class="progress-main-container">
                               <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Fit</div>
                               <div class="progress-bar-container" >
                                 <div class="progress-placeholder">
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                 </div>
                                 <div class="progress-active">
                                  ${rating1} 
                                 </div>
                               </div> 
                             </div>
                          
                             <div class="progress-main-container">
                             <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Quality</div>
                               <div class="progress-bar-container" >
                                 <div class="progress-placeholder">
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                   <div class="progress-placeholder-item"> </div>
                                 </div>
                                <div class="progress-active">
                                  ${rating2} 
                                </div>
                              </div> 
                            </div>
                            
                          <div class="progress-main-container">
                            <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Delivery</div>
                              <div class="progress-bar-container" >
                                <div class="progress-placeholder">
                                  <div class="progress-placeholder-item"> </div>
                                  <div class="progress-placeholder-item"> </div>
                                  <div class="progress-placeholder-item"> </div>
                                  <div class="progress-placeholder-item"> </div>
                                  <div class="progress-placeholder-item"> </div>
                                </div>
                                <div class="progress-active">
                                  ${rating3} 
                                </div>
                              </div> 
                            </div>
                          </div>
                        </div>
                     
                        <div class="custom-review-content-container padding-left-40 mobile-padding-left-0 margin-left-26 padding-top-mob-15 margin-top-mob-15" >               
                          <div class="custom-review-content" >
                            ${item.content}
                          </div> 
                          <div class="custom-reviews-info-block" >
                            <div class="custom-reviews-info" > 
                              <div class="custom-review-author">Posted By ${item.author} (${item.authorloc}) <span class="review-date-sep">|</span><span class="review-date" id="date-${item.index}"></span></div> 
                              <div class="custom-reviews-product-info"> ${item.ptitle}</div> 
                              <div class="custom-reviews-product" >${item.pdetails}</div> 
                            </div>
                            <div class="">
                              <a target="_blank" href="https://www.shopperapproved.com/reviews/coveranything.com"><img src="https://cdn.shopify.com/s/files/1/0699/7816/1398/files/more-sa-reviews.png?v=1715594474"></a>
                            </div>
                          </div> 
                        </div>
                      </div>`;
              });
              str = str + `</div>`;
            });
            str = str + `</div>`;
            str = str + `</div>`;
          } else {
            var str = "";
            str = str + `<div class="swiper mySwiper">`;
            str = str + `<div class="swiper-wrapper">`;
            result = data;
            result.forEach((item) => {
              str = str + `<div class="swiper-slide">`;
              var rating1 = "";
              var r1count = parseInt(item.rating1) || 5;
              for (var i = 0; i < r1count; i++) {
                rating1 = rating1 + `<div class="progress-active-item"> </div>`;
              }
              var rating2 = "";
              var r2count = parseInt(item.rating2) || 5;
              for (var i = 0; i < r2count; i++) {
                rating2 = rating2 + `<div class="progress-active-item"> </div>`;
              }
              var rating3 = "";
              var r3count = parseInt(item.rating3) || 5;
              for (var i = 0; i < r3count; i++) {
                rating3 = rating3 + `<div class="progress-active-item"> </div>`;
              }
              var ratingtotal = "";
              var totalRating = r1count + r2count + r3count;
              var totalper = item.ratingall;
              var totalpercentage = totalper;
              for (var i = 0; i < 5; i++) {
                if (i < totalper) {
                  ratingtotal =
                    ratingtotal +
                    `<svg id="Star" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25">
                  <path id="Path_2712" data-name="Path 2712" d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" transform="translate(-207.22 1546.716)" stroke="#EB7100" fill="#EB7100"></path>
                </svg>`;
                } else {
                  ratingtotal =
                    ratingtotal +
                    `<svg id="Star" xmlns="http://www.w3.org/2000/svg" width="26.287" height="25" viewBox="0 0 26.287 25">
                  <path id="Path_2712" data-name="Path 2712" d="M220.363-1546.716l3.1,9.549h10.041l-8.123,5.9,3.1,9.549-8.123-5.9-8.123,5.9,3.1-9.549-8.123-5.9h10.041Z" transform="translate(-207.22 1546.716)" stroke="#EB7100" fill="transparent"></path>
                </svg>`;
                }
              }
              str =
                str +
                `<div class="custom-review-wrapper">
                     <div class="custom-review-star-block"> 
                      <div class="custom-review-heading font-size-20 font-size-mob-17 font-weight-600" style="color:#4d4d4d;">${item.heading}</div>
                      <div class="custom-main-star-rating"><div class="stars-wrapper">${ratingtotal}</div> <span>${totalpercentage}/5</span></div>
                      <div class="custom-review-star-wrapper"> 
                         <div class="progress-main-container">
                           <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Fit</div>
                           <div class="progress-bar-container" >
                             <div class="progress-placeholder">
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                             </div>
                             <div class="progress-active">
                              ${rating1} 
                             </div>
                           </div> 
                         </div>
                      
                         <div class="progress-main-container">
                         <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Quality</div>
                           <div class="progress-bar-container" >
                             <div class="progress-placeholder">
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                               <div class="progress-placeholder-item"> </div>
                             </div>
                            <div class="progress-active">
                              ${rating2} 
                            </div>
                          </div> 
                        </div>
                        
                      <div class="progress-main-container">
                        <div class="progress-bar-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >Delivery</div>
                          <div class="progress-bar-container" >
                            <div class="progress-placeholder">
                              <div class="progress-placeholder-item"> </div>
                              <div class="progress-placeholder-item"> </div>
                              <div class="progress-placeholder-item"> </div>
                              <div class="progress-placeholder-item"> </div>
                              <div class="progress-placeholder-item"> </div>
                            </div>
                            <div class="progress-active">
                              ${rating3} 
                            </div>
                          </div> 
                        </div>
                      </div>
                    </div>
                 
                    <div class="custom-review-content-container padding-left-40 mobile-padding-left-0 margin-left-26 padding-top-mob-15 margin-top-mob-15" >               
                      <div class="custom-review-content" >
                        ${item.content}
                      </div> 
                      <div class="custom-reviews-info-block" >
                        <div class="custom-reviews-info" > 
                          <div class="custom-review-author">Posted By ${item.author} (${item.authorloc}) <span class="review-date-sep">|</span><span class="review-date" id="date-${item.index}"></span></div> 
                          <div class="custom-reviews-product-info"> ${item.ptitle}</div> 
                          <div class="custom-reviews-product" >${item.pdetails}</div> 
                        </div>
                        <div class="">
                          <a href="https://www.shopperapproved.com/reviews/coveranything.com"><img src="https://cdn.shopify.com/s/files/1/0699/7816/1398/files/more-sa-reviews.png?v=1715594474"></a>
                        </div>
                      </div> 
                    </div>
                  </div>`;

              str = str + `</div>`;
            });
            str = str + `</div>`;
            str = str + `</div>`;
          }

          $(this3).find(".custom-reviews-container-wrapper").html(str);
        }

        function generatePagination() {
          var pagination = $(this3).find(".custom-pagination-new");
          pagination.empty();

          pagination.append(`<a class="sw-button-prev"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clip-path="url(#clip0_24_3)">
              <path d="M7.6386 0.291287C7.77852 0.431239 7.85712 0.621048 7.85712 0.818929C7.85712 1.01683 7.77852 1.20662 7.6386 1.3466L3.94431 5.04088L7.6386 8.7352C7.77455 8.87596 7.84978 9.06448 7.84808 9.26016C7.84638 9.45585 7.76789 9.64303 7.62951 9.78141C7.49114 9.91978 7.30395 9.99827 7.10827 9.99997C6.91258 10.0017 6.72406 9.92645 6.5833 9.7905L2.36135 5.56855C2.22143 5.4286 2.14283 5.23879 2.14283 5.04088C2.14283 4.843 2.22143 4.65319 2.36135 4.51324L6.5833 0.291287C6.72326 0.151382 6.91305 0.0727626 7.11095 0.0727626C7.30885 0.0727626 7.49865 0.151382 7.6386 0.291287Z" fill="#4D4D4D"/>
              </g>
              <defs>
              <clipPath id="clip0_24_3">
              <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 -1 10 10)"/>
              </clipPath>
              </defs>
            </svg>
            PREV</a
          >`);

          pagination.append(`<a class="sw-button-next" >
              NEXT  
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 24 42"
                fill="none">
                <path d="M0.917757 40.7766C0.330118 40.1888 -5.0137e-07 39.3916 -5.0137e-07 38.5605C-5.0137e-07 37.7293 0.330118 36.9322 0.917757 36.3443L16.4338 20.8283L0.917757 5.31218C0.346771 4.72099 0.0308254 3.9292 0.0379672 3.10732C0.0451091 2.28545 0.374767 1.49926 0.95594 0.918091C1.53711 0.336917 2.3233 0.00726254 3.14517 0.000120696C3.96705 -0.00702115 4.75884 0.308925 5.35003 0.879911L23.0822 18.6121C23.6699 19.1999 24 19.9971 24 20.8283C24 21.6594 23.6699 22.4566 23.0822 23.0444L5.35003 40.7766C4.76221 41.3642 3.96507 41.6944 3.13389 41.6944C2.30272 41.6944 1.50557 41.3642 0.917757 40.7766Z" fill="#4d4d4d"></path>
              </svg> 
              </a>`);

          $.fn.hasAttr = function (name) {
            return this.attr(name) !== undefined;
          };
          $(this3)
            .find(".custom-pagination-new")
            .find("a")
            .click(function (e) {
              e.preventDefault();
              e.stopPropagation();
              if ($(this).hasAttr("data-page")) {
                setDataInPage(this3.jsonarr, $(this).data("page"));

                generatePagination();
                setDates();
              }
            });
          this3.swiper = new Swiper(".mySwiper", {
            spaceBetween: 30,
            navigation: {
              nextEl: ".sw-button-next",
              prevEl: ".sw-button-prev",
            },
          });
        }
        function setDates() {
          // $(".review-date").each(function (i) {
          //   var $this = $(this);
          //   var newID = "date-" + (i + 1);
          //   $(this).attr("id", newID);
          // });

          var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          var d1 = new Date();
          d1.setDate(d1.getDate() - 3);
          $("#date-1").html(
            monthNames[d1.getMonth()] +
              " " +
              d1.getDate() +
              ", " +
              d1.getFullYear()
          );

          var d2 = new Date();
          d2.setDate(d2.getDate() - 5);
          $("#date-2").html(
            monthNames[d2.getMonth()] +
              " " +
              d2.getDate() +
              ", " +
              d2.getFullYear()
          );

          var d3 = new Date();
          d3.setDate(d3.getDate() - 7);
          $("#date-3").html(
            monthNames[d3.getMonth()] +
              " " +
              d3.getDate() +
              ", " +
              d3.getFullYear()
          );

          var d4 = new Date();
          d4.setDate(d4.getDate() - 10);
          $("#date-4").html(
            monthNames[d4.getMonth()] +
              " " +
              d4.getDate() +
              ", " +
              d4.getFullYear()
          );

          var d5 = new Date();
          d5.setDate(d5.getDate() - 13);
          $("#date-5").html(
            monthNames[d5.getMonth()] +
              " " +
              d5.getDate() +
              ", " +
              d5.getFullYear()
          );

          var d6 = new Date();
          d6.setDate(d6.getDate() - 18);
          $("#date-6").html(
            monthNames[d6.getMonth()] +
              " " +
              d6.getDate() +
              ", " +
              d6.getFullYear()
          );

          var d7 = new Date();
          d7.setDate(d7.getDate() - 21);
          $("#date-7").html(
            monthNames[d7.getMonth()] +
              " " +
              d7.getDate() +
              ", " +
              d7.getFullYear()
          );

          var d8 = new Date();
          d8.setDate(d8.getDate() - 27);
          $("#date-8").html(
            monthNames[d8.getMonth()] +
              " " +
              d8.getDate() +
              ", " +
              d8.getFullYear()
          );

          var d9 = new Date();
          d9.setDate(d9.getDate() - 32);
          $("#date-9").html(
            monthNames[d9.getMonth()] +
              " " +
              d9.getDate() +
              ", " +
              d9.getFullYear()
          );

          var d10 = new Date();
          d10.setDate(d10.getDate() - 33);
          $("#date-10").html(
            monthNames[d10.getMonth()] +
              " " +
              d10.getDate() +
              ", " +
              d10.getFullYear()
          );

          var d11 = new Date();
          d11.setDate(d11.getDate() - 35);
          $("#date-11").html(
            monthNames[d11.getMonth()] +
              " " +
              d11.getDate() +
              ", " +
              d11.getFullYear()
          );

          var d12 = new Date();
          d12.setDate(d12.getDate() - 38);
          $("#date-12").html(
            monthNames[d12.getMonth()] +
              " " +
              d12.getDate() +
              ", " +
              d12.getFullYear()
          );

          var d13 = new Date();
          d13.setDate(d13.getDate() - 41);
          $("#date-13").html(
            monthNames[d13.getMonth()] +
              " " +
              d13.getDate() +
              ", " +
              d13.getFullYear()
          );

          var d14 = new Date();
          d14.setDate(d14.getDate() - 46);
          $("#date-14").html(
            monthNames[d14.getMonth()] +
              " " +
              d14.getDate() +
              ", " +
              d14.getFullYear()
          );

          var d15 = new Date();
          d15.setDate(d15.getDate() - 52);
          $("#date-15").html(
            monthNames[d15.getMonth()] +
              " " +
              d15.getDate() +
              ", " +
              d15.getFullYear()
          );

          var d16 = new Date();
          d16.setDate(d16.getDate() - 54);
          $("#date-16").html(
            monthNames[d16.getMonth()] +
              " " +
              d16.getDate() +
              ", " +
              d16.getFullYear()
          );

          var d17 = new Date();
          d17.setDate(d17.getDate() - 59);
          $("#date-17").html(
            monthNames[d17.getMonth()] +
              " " +
              d17.getDate() +
              ", " +
              d17.getFullYear()
          );

          var d18 = new Date();
          d18.setDate(d18.getDate() - 60);
          $("#date-18").html(
            monthNames[d18.getMonth()] +
              " " +
              d18.getDate() +
              ", " +
              d18.getFullYear()
          );

          var d19 = new Date();
          d19.setDate(d19.getDate() - 66);
          $("#date-19").html(
            monthNames[d19.getMonth()] +
              " " +
              d19.getDate() +
              ", " +
              d19.getFullYear()
          );

          var d20 = new Date();
          d20.setDate(d20.getDate() - 72);
          $("#date-20").html(
            monthNames[d20.getMonth()] +
              " " +
              d20.getDate() +
              ", " +
              d20.getFullYear()
          );

          var d21 = new Date();
          d21.setDate(d21.getDate() - 73);
          $("#date-21").html(
            monthNames[d21.getMonth()] +
              " " +
              d21.getDate() +
              ", " +
              d21.getFullYear()
          );

          var d22 = new Date();
          d22.setDate(d22.getDate() - 75);
          $("#date-22").html(
            monthNames[d22.getMonth()] +
              " " +
              d22.getDate() +
              ", " +
              d22.getFullYear()
          );

          var d23 = new Date();
          d23.setDate(d23.getDate() - 77);
          $("#date-23").html(
            monthNames[d23.getMonth()] +
              " " +
              d23.getDate() +
              ", " +
              d23.getFullYear()
          );

          var d24 = new Date();
          d24.setDate(d24.getDate() - 78);
          $("#date-24").html(
            monthNames[d24.getMonth()] +
              " " +
              d24.getDate() +
              ", " +
              d24.getFullYear()
          );

          var d25 = new Date();
          d25.setDate(d25.getDate() - 79);
          $("#date-25").html(
            monthNames[d25.getMonth()] +
              " " +
              d25.getDate() +
              ", " +
              d25.getFullYear()
          );

          var d26 = new Date();
          d26.setDate(d26.getDate() - 82);
          $("#date-26").html(
            monthNames[d26.getMonth()] +
              " " +
              d26.getDate() +
              ", " +
              d26.getFullYear()
          );

          var d27 = new Date();
          d27.setDate(d27.getDate() - 89);
          $("#date-27").html(
            monthNames[d27.getMonth()] +
              " " +
              d27.getDate() +
              ", " +
              d27.getFullYear()
          );

          var d28 = new Date();
          d28.setDate(d28.getDate() - 94);
          $("#date-28").html(
            monthNames[d28.getMonth()] +
              " " +
              d28.getDate() +
              ", " +
              d28.getFullYear()
          );

          var d29 = new Date();
          d29.setDate(d29.getDate() - 97);
          $("#date-29").html(
            monthNames[d29.getMonth()] +
              " " +
              d29.getDate() +
              ", " +
              d29.getFullYear()
          );

          var d30 = new Date();
          d30.setDate(d30.getDate() - 98);
          $("#date-30").html(
            monthNames[d30.getMonth()] +
              " " +
              d30.getDate() +
              ", " +
              d30.getFullYear()
          );
        }
      }
    }
  );
}

function ratingStar(star) {
  star.click(function () {
    var stars = $(this).parents(".ratingW").find("li");
    stars.removeClass("on");
    var thisIndex = $(this).parents("li").index();
    for (var i = 0; i <= thisIndex; i++) {
      stars.eq(i).addClass("on");
    }
    putScoreNow(thisIndex + 1);
    var val = thisIndex + 1 + "";
    $(this).parents(".star-rating").find("input").attr("value", val);
  });
}

function putScoreNow(i) {
  $(".scoreNow").html(i);
}

$(function () {
  if ($(".ratingW").length > 0) {
    ratingStar($(".ratingW li a"));
  }
  $(".review-popup-opener").click(function () {
    $(".modal-raw").show();
  });
  $(".close").click(function () {
    $(".modal-raw").hide();
  });
});
